import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SECTIONS, ProfileOrganization, ProfileDocumentModel } from 'Pages/profileOrganization'
import { RequestParams, ResponseCatalog } from 'Models'
import { Callback } from 'Src/types/utilTypes'

export type ProfileOrganizationState = {
	section: SECTIONS
	list: ResponseCatalog<ProfileOrganization>
	current: ProfileOrganization | null
	requestParams: RequestParams
	isLoading: boolean
	documents: ProfileDocumentModel[]
}

const initialState: ProfileOrganizationState = {
	section: SECTIONS.REQUISITES,
	list: new ResponseCatalog<ProfileOrganization>(),
	current: null,
	requestParams: new RequestParams(),
	isLoading: false,
	documents: [],
}

export namespace ProfileOrganizationNS {
	export type SetSection = PayloadAction<SECTIONS>

	export type GetList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type GetOne = PayloadAction<string | number>
	export type SetOne = PayloadAction<ProfileOrganization>
	export type SetList = PayloadAction<ResponseCatalog<ProfileOrganization>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetIsLoading = PayloadAction<boolean>
	export type GetAllDocument = PayloadAction<number>
	export type SetAllDocument = PayloadAction<ProfileDocumentModel[]>
}

export const profileOrganizationSlice = createSlice({
	name: 'profile_organization',
	initialState,
	reducers: {
		setSection: (state, action: ProfileOrganizationNS.SetSection) => {
			state.section = action.payload
		},

		getList: (state, action: ProfileOrganizationNS.GetList) => {},
		setList: (state, action: ProfileOrganizationNS.SetList) => {
			state.list = action.payload
		},
		setRequestParams: (state, action: ProfileOrganizationNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.list = new ResponseCatalog<ProfileOrganization>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: ProfileOrganizationNS.GetOne) => {},
		setOne: (state, action: ProfileOrganizationNS.SetOne) => {
			state.current = action.payload
		},
		setIsLoading: (state, action: ProfileOrganizationNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		getAllDocument: (state, action: ProfileOrganizationNS.GetAllDocument) => {},
		setAllDocument: (state, action: ProfileOrganizationNS.SetAllDocument) => {
			state.documents = action.payload
		},
		clearAllDocument: (state) => {
			state.documents = []
		},
	},
})
